import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

export type ToastKind = 'success' | 'error' | 'info' | 'warning';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  success(message: string, duration = 3200): void {
    this.show(message, 'success', duration);
  }

  error(message: string, duration = 4500): void {
    this.show(message, 'error', duration);
  }

  info(message: string, duration = 3500): void {
    this.show(message, 'info', duration);
  }

  warning(message: string, duration = 4000): void {
    this.show(message, 'warning', duration);
  }

  /** Convenience aliases matching common CRUD events. */
  saved(message = 'Record saved successfully.'): void {
    this.success(message);
  }

  updated(message = 'Record updated successfully.'): void {
    this.success(message);
  }

  deleted(message = 'Record deleted successfully.'): void {
    this.success(message);
  }

  private show(message: string, kind: ToastKind, duration: number): void {
    const text = (message || '').trim();
    if (!text) return;

    const config: MatSnackBarConfig = {
      duration,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['tt-toast', `tt-toast--${kind}`]
    };

    this.snackBar.open(text, 'Close', config);
  }
}
